import { validator } from "@/utils/validator";

export const adminUserSchema = validator.object().shape({
  fullName: validator.string().trim().emptyToNull().label("氏名").required(),
  email: validator.string().trim().emptyToNull().email().max(60).label("メールアドレス").required(),
  adminRole: validator.string().isSelection().trim().emptyToNull().label("担当").required(),
});
